import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.83 9.431a.3.3 0 0 1-.001-.303 5.36 5.36 0 0 0 .682-2.629q0-.498-.087-.973a.3.3 0 0 1 .094-.281 3.15 3.15 0 0 1 2.043-.746 3.234 3.234 0 0 1 3.067 4.252 3.16 3.16 0 0 1-2.041 2.029c-1.549.484-3.021-.179-3.757-1.349m4.28 2.849h-1.982c-.266 0-.403.323-.21.507 1.42 1.352 2.083 3.301 2.083 5.233v1.18a.3.3 0 0 0 .3.3h3.7a.5.5 0 0 0 .5-.5v-2.32c-.001-2.03-1.151-4.4-4.391-4.4M9.009 10.5c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4m1.991 2H7c-4.06 0-5.5 2.973-5.5 5.519V21a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5v-2.981c0-2.546-1.44-5.519-5.5-5.519"
    }, null, -1)
  ])))
}
export default { render: render }